import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
import CommonSwitch from "../switch";
import ConfirmSwitchModal from "../confirmSwitchModal";
import { Modal, Button } from "@material-ui/core";
import { useState, useEffect } from "react";
import { reactivateVendorAction, suspendVendorAction } from "../../containers/dashboard/action";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((th) => ({
  listContainer: {
    marginTop: "30px",
    "& .block": {
      cursor: "pointer",
      background: theme.colors.White,
      boxShadow: "0px 2px 15px #D0CFDB99",
      borderRadius: "15px",
      padding: "15px 30px",
      display: "flex",
      marginBottom: "15px",
      "& .left": {
        flex: "0.4",
        display: "flex",
        alignItems: "center",
        "& .logoContainer": {
          position: "relative",
          height: "85px",
          width: "85px",
          minWidth: "85px",
          borderRadius: "50%",
          border: `1px solid ${theme.colors.Zumthor}`,
          backgroundColor: theme.colors.White,
          overflow: "hidden",
          "& img": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          },
        },
        "& .merchantInfoContainer": {
          marginLeft: "25px",
          color: theme.colors.Violet,
          "& .merchantName": {
            fontSize: "22px",
            fontFamily: theme.fontFamily.MARKPROBOLD,
            marginBottom: "10px",
          },
          "& .merchantEmail": {
            fontSize: "12px",
            fontFamily: theme.fontFamily.MARKPRO,
          },
        },
      },
      "& .right": {
        flex: "0.6",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& .infoContainer": {
          color: theme.colors.Violet,
          "& .label": {
            fontSize: "12px",
            fontFamily: theme.fontFamily.MARKPRO,
          },
          "& .val": {
            fontSize: "16px",
            fontFamily: theme.fontFamily.MARKPROHEAVY,
          },
        },
        "& .borderContainer": {
          border: `1px solid ${theme.colors.Zumthor}`,
          height: "57px",
          margin: "0px 5px",
        },
      },
    },
  },
  statusBadge: {
    display: "inline-block",
    padding: "5px 15px",
    borderRadius: "20px",
    fontSize: "12px",
    fontFamily: theme.fontFamily.MARKPROBOLD,
    textTransform: "uppercase",
  },
  statusPending: {
    backgroundColor: theme.colors.Zumthor,
    color: theme.colors.DodgerBlue,
  },
  statusApproved: {
    backgroundColor: theme.colors.MintGreen,
    color: theme.colors.Violet,
  },
  statusRejected: {
    backgroundColor: theme.colors.Cinderella,
    color: theme.colors.Monza,
  },
  resendInvitationLink: {
    fontSize: "12px",
    color: theme.colors.DodgerBlue,
    cursor: "pointer",
    marginTop: "5px",
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.colors.White,
    border: '2px solid #000',
    boxShadow: th.shadows[5],
    padding: th.spacing(2, 4, 3),
    outline: 'none',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '20px',
  },
}));

const canBeActivatedOrDeactivated = (merchant) => {
  return merchant?.status?.toLowerCase() === "active" || merchant?.status?.toLowerCase() === "suspended";
};

function MerchantList({ data, onMerchantClick, onResendInvitationMethod = null, canEditVendors = true }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [confirmSwitch, setConfirmSwitch] = useState(false);
  const [confirmation, setConfirmation] = useState(null);
  const [switchRecord, setSwitchRecord] = useState(null);
  const [switchMethod, setSwitchMethod] = useState(null);
  const [confirmResendInvitationDetails, setConfirmResendInvitationDetails] = useState({
    merchantId: null,
    open: false,
    merchantName: "",
  });
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = (merchant) => {
    setConfirmResendInvitationDetails({
      merchantId: merchant.id,
      merchantName: merchant.business_name || merchant.merchant_name,
      open: true,
    });
  };

  const handleCancelResendInvitation = () => {
    setConfirmResendInvitationDetails({
      merchantId: null,
      open: false,
      merchantName: ""
    });
  }


  useEffect(() => {
    if (
      confirmation === "yes" &&
      switchRecord &&
      switchRecord.id &&
      switchMethod
    ) {
      if (switchMethod === "reactivate") {
        dispatch(reactivateVendorAction(switchRecord.id));
      } else if (switchMethod === "suspend") {
        dispatch(suspendVendorAction(switchRecord.id));
      }
      setSwitchRecord(null);
      setSwitchMethod(null);
      setConfirmation(null);
    }
  }, [confirmation, switchRecord, switchMethod, dispatch]);

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "approved":
        return classes.statusApproved;
      case "rejected":
        return classes.statusRejected;
      default:
        return classes.statusPending;
    }
  };

  return (
    <div className={classes.listContainer}>
      {data && data.length
        ? data.map((each, index) => {
          return (
            <div
              className="block"
              key={index}
              onClick={(e) => {
                if (onMerchantClick && e.target.tagName.toLowerCase() !== "button" && e.target.tagName.toLowerCase() !== "a") {
                  onMerchantClick(each);
                }
              }}
            >
              <div className="left">
                <div className="logoContainer">
                  {each?.business_logo ? (
                    <img src={each.business_logo} alt={each.business_name || "merchantLogo"} />
                  ) : each?.qr_code_image ? (
                    <img src={each.qr_code_image} alt="merchantLogo" />
                  ) : (
                    <div
                      style={{
                        fontSize: "30px",
                        color: "#3E83FA",
                        fontWeight: "bold",
                      }}
                    >
                      {each?.business_name?.charAt(0)?.toUpperCase() || "M"}
                    </div>
                  )}
                </div>
                <div className="merchantInfoContainer">
                  <div className="merchantName">{each?.business_name || each?.merchant_name}</div>
                  <div className="merchantEmail">{each?.owner_email}</div>
                  {each?.location && (
                    <div
                      className="merchantEmail"
                      style={{ marginTop: "5px" }}
                    >
                      {each.location}
                    </div>
                  )}
                </div>
              </div>
              <div className="right">
                <div className="infoContainer">
                  <div className="label">Status</div>
                  <div className="val">
                    <span
                      className={`${classes.statusBadge} ${getStatusBadgeClass(
                        each?.status
                      )}`}
                    >
                      {each?.status || "pending"}
                    </span>
                  </div>
                </div>
                <div className="borderContainer" />
                <div className="infoContainer">
                  <div className="label">Total Transactions</div>
                  <div className="val" style={{ padding: "10px 0px" }}>
                    {new Intl.NumberFormat().format(each?.total_transactions_count || each?.total_transactions || 0)}
                  </div>
                </div>
                <div className="borderContainer" />
                <div className="infoContainer">
                  <div className="label">Registration Date</div>
                  <div className="val" style={{ padding: "10px 0px" }}>
                    {each?.created_at
                      ? new Date(each.created_at).toLocaleDateString()
                      : "N/A"}
                  </div>
                </div>
                <div className="borderContainer" />
                <div className="infoContainer">
                  <div className="label">Account Status</div>
                  <div className="val">
                    <span style={{ fontSize: "12px" }}>Activated</span>
                    <CommonSwitch
                      name={each.id}
                      checked={each.is_active}
                      disabled={!canBeActivatedOrDeactivated(each) || !canEditVendors}
                      onClick={(e) => {
                        e.stopPropagation();
                        setConfirmSwitch(true);
                        setSwitchRecord(each);
                        // If currently active, suspend; if inactive, reactivate
                        setSwitchMethod(each.is_active ? "suspend" : "reactivate");
                      }}
                    />
                  </div>
                  {canEditVendors && !canBeActivatedOrDeactivated(each) && <a
                    className={classes.resendInvitationLink}
                    onClick={(e) => {
                      e.preventDefault();
                      handleOpenModal(each);
                    }}>Resend Invitation</a>}
                </div>
              </div>
            </div>
          );
        })
        : null}
      <ConfirmSwitchModal
        openModal={confirmSwitch}
        setConfirmation={(confirmation) => {
          setConfirmSwitch((temp) => !temp);
          setConfirmation(confirmation);
        }}
      />
      <Modal open={confirmResendInvitationDetails.open} onClose={() => { handleCancelResendInvitation() }} className={classes.modal}>
        <div className={classes.paper}>
          <p>Are you sure you want to resend invitation for <strong>{confirmResendInvitationDetails.merchantName}</strong>?</p>
          <div className={classes.buttonContainer}>
            <Button variant="contained" style={{ backgroundColor: '#3E83FA' }} onClick={() => {
              onResendInvitationMethod?.({ vendor_id: confirmResendInvitationDetails.merchantId });
              setConfirmResendInvitationDetails({
                merchantId: null,
                open: false,
                merchantName: ""
              });
            }}>Yes, Proceed</Button>
            <Button variant="contained" style={{ backgroundColor: '#FF3B59' }} onClick={() => { handleCancelResendInvitation(); }}>Cancel</Button>
          </div>
        </div>
      </Modal>

    </div>
  );
}

export default MerchantList;

